/** Crockford-style 26-char ULID generator (sufficient for client-side IDs). */
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ'

export function ulid(): string {
  const now = Date.now()
  let timePart = ''
  let t = now
  for (let i = 0; i < 10; i++) {
    timePart = CROCKFORD[t % 32] + timePart
    t = Math.floor(t / 32)
  }
  let randPart = ''
  const buf = new Uint8Array(16)
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(buf)
  } else {
    for (let i = 0; i < 16; i++) buf[i] = Math.floor(Math.random() * 256)
  }
  for (let i = 0; i < 16; i++) {
    randPart += CROCKFORD[buf[i] % 32]
  }
  return timePart + randPart
}
